import {
  createLead,
  createNote,
  deleteLead,
  deleteNote,
  downloadLead,
  downloadSelectedLead,
  editNote,
  getAllLeads,
  getHotLeads,
  getInterestedLeads,
  getSingleLead,
  getWarmLeads,
} from "../../../slices/leads/leadManagementSlice";
import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";
import { AppDispatch } from "../../../slices/store";
import { deleteTempCallRecordingResource, uploadFileResource } from "../../../slices/users/userManagementSlice";
import { LEAD_TYPE, LeadData } from "../models/ILead";
import { Note, NoteEdit } from "../../../slices/leads/types";
import { UserRole } from "../../../utils";
import { protectedResources } from "../../../app/authConfig";


export const handleDeleteCardService = (
  data: any,
  reqRequests: any,
  setIsLoading: any,
  dispatch: AppDispatch,
  addAlert: Function,
  shouldRedirect: boolean,
  navigate: Function,
  getLeads: any,
  protectedResources: any,
) => {
  const params = {
    id: data.id,
    accessToken: localStorage.getItem("AccessToken") || "llll",
    url: protectedResources.apiTodoList.endpoint + "/leads/" + data.id,
  };
  dispatch(deleteLead(params))
    .then((r: any) => {
      setIsLoading(true);
      scrollToTop();
      if (r?.payload?.success === true) {
        addAlert("Lead Deleted Successfully", "success", true);
        dispatch(getLeads(reqRequests)).then((r: any) => {
          if (r.payload.succeeded) {
            setIsLoading(false);
            if (shouldRedirect) {
              navigate(-1);
            }
          }
        });
      }
    })
    .catch((e) => {
      addAlert("Lead Deleted Failed", "failed", true);
    });
};

export const handleDownloadLeadService = (
  reqRequests: any,
  setIsLoading: any,
  dispatch: AppDispatch,
  addAlert: Function
) => {
  dispatch(downloadLead(reqRequests));
};

export const handleDownloadSelectedLeadService = (
  reqRequests: any,
  setIsLoading: any,
  dispatch: AppDispatch,
  addAlert: Function
) => {
  dispatch(downloadSelectedLead(reqRequests));
};

export const handleCreateLeadService = (
  inputValue: LeadData,
  accessToken: string,
  endpoint: string | undefined,
  reqRequests: any,
  dispatch: AppDispatch,
  setIsLoading: any,
  navigate: Function,
  record: any,
  status: string,
  addAlert: any,
  userRole: UserRole,
  leadType: LEAD_TYPE
) => {
  const {
    firstName,
    lastName,
    businessType,
    company,
    customer,
    email,
    jobTitle,
    mobile,
    noOfEmployees,
    note,
    phone,
    comment,
    revenue,
    addressOne,
    job,
  } = inputValue;
  const customerId = customer?.value.toString();
  let addressTwo;

  if (inputValue.addressTwo?.addressLineOne) {
    addressTwo = {
      addressLineOne: inputValue.addressTwo?.addressLineOne || null,
      addressLineTwo: inputValue.addressTwo?.addressLineTwo || null,
      city: inputValue.addressTwo?.city || null,
      state: inputValue.addressTwo?.state || null,
      country: inputValue.addressTwo?.country || null,
    };
  } else {
    addressTwo = null;
  }

  const lead = {
    assignedUsers: [
      {
        userId: customerId,
        jobIds: [job?.value],
      },
    ],
    firstName,
    lastName,
    mobile,
    email,
    jobTitle,
    company,
    phone,
    numberOfEmployees: parseInt(noOfEmployees),
    revenue: parseInt(revenue),
    businessType,
    note,
    addressOne: {
      addressLineOne: addressOne?.addressLineOne || null,
      addressLineTwo: addressOne?.addressLineTwo || null,
      city: addressOne?.city || null,
      state: addressOne?.state || null,
      country: addressOne?.country || null,
    },
    addressTwo: addressTwo,
    socialMediaData: [
      {
        type: 1,
        link: "https://lk.linkedin.com/",
      },
      {
        type: 2,
        link: "https://www.facebook.com/",
      },
    ],
    comment,
    leadType,
  };

  let userParams = {
    lead,
    accessToken,
    url: endpoint + `/leads`,
  };

  dispatch(createLead(userParams))
    .then((r: any) => {
      scrollToTop();
      setIsLoading(true);
      if (r.payload) {
        const ReferenceId = r.payload.id;
        const params = {
          accessToken,
          selectedFile: record,
          Reference: 2,
          ReferenceId,
          url: endpoint + `/resources`,
        };
        dispatch(uploadFileResource(params)).then((r: any) => {
          if (r.payload) {
            const fileName = r?.payload?.name;
            if (status === "idle") {
              dispatch(getAllLeads(reqRequests));
              const getHotLeadsParams = { ...reqRequests, leadType: "HighIntent" };
              dispatch(getHotLeads(getHotLeadsParams));
              const getWarmLeadsParams = {
                ...reqRequests,
                leadType: "MediumIntent",
              };
              dispatch(getWarmLeads(getWarmLeadsParams));
              const getInterestedLeadsParams = {
                ...reqRequests,
                leadType: "LowIntent",
              };
              dispatch(getInterestedLeads(getInterestedLeadsParams));

              addAlert("Lead Created Successfully", "success", true);
              localStorage.removeItem("recordingFile");
              setIsLoading(false);
              localStorage.removeItem("allLeadsActivePage");
              localStorage.removeItem("hotLeadsActivePage");
              localStorage.removeItem("interestedLeadsActivePage");
              localStorage.removeItem("warmLeadsActivePage");

              if (userRole === UserRole.Operator) {
                navigate("/leads/all-leads");
                return;
              } else {
                navigate("/");
              }
            }
          }
        });
        dispatch(
          deleteTempCallRecordingResource({
            accessToken,
            url: protectedResources.apiTodoList.endpoint!,
            name: localStorage.getItem("recordingFile") || "",
          })
        );
        localStorage.removeItem("recordingFile");
        localStorage.removeItem("existingRecording");
      } else {
        setIsLoading(false);
        addAlert("Lead Created  Failed", "failed", true);
      }
    })
    .catch((e) => {
      setIsLoading(false);
      addAlert("Lead created failed", "failed", true);
    });
};

export const handleCreateChat = (
  protectedResources: any,
  note: Note,
  dispatch: AppDispatch,
  leadId: number
) => {
  const params = {
    note: note,
    accessToken: localStorage.getItem("AccessToken") || "llll",
    url: protectedResources.apiTodoList.endpoint + "/leads/notes",
  };
  dispatch(createNote(params))
    .then((r) => {
      if (r.payload) {
        const reqRequests = {
          accessToken: localStorage.getItem("AccessToken") || "llll",
          url: protectedResources.apiTodoList.endpoint,
          id: leadId,
        };
        dispatch(getSingleLead(reqRequests));
      }
    })
    .catch((e) => console.log(e));
};

export const handleEditChat = (
  protectedResources: any,
  note: NoteEdit,
  dispatch: AppDispatch,
  leadId: number
) => {
  const params = {
    note: note,
    accessToken: localStorage.getItem("AccessToken") || "llll",
    url: protectedResources.apiTodoList.endpoint + "/leads/notes/" + note.id,
  };
  dispatch(editNote(params))
    .then((r) => {
      if (r.payload) {
        const reqRequests = {
          accessToken: localStorage.getItem("AccessToken") || "llll",
          url: protectedResources.apiTodoList.endpoint,
          id: leadId,
        };
        dispatch(getSingleLead(reqRequests));
      }
    })
    .catch((e) => console.log(e));
};

export const handleDeleteChat = (
  protectedResources: any,
  dispatch: AppDispatch,
  leadId: number,
  noteId: number
) => {
  const params = {
    id: noteId,
    accessToken: localStorage.getItem("AccessToken") || "llll",
    url: protectedResources.apiTodoList.endpoint + "/leads/notes/" + noteId,
  };
  dispatch(deleteNote(params))
    .then((r) => {
      if (r.payload) {
        const reqRequests = {
          accessToken: localStorage.getItem("AccessToken") || "llll",
          url: protectedResources.apiTodoList.endpoint,
          id: leadId,
        };
        dispatch(getSingleLead(reqRequests));
      }
    })
    .catch((e) => console.log(e));
};
